<!--
 * @Author: your name
 * @Date: 2020-12-25 16:34:05
 * @LastEditTime: 2020-12-25 17:06:42
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zcjb\src\components\fiexd\marin.vue
-->
<template>
  <div class="fixed">
    <div>
      <el-tooltip placement="left" effect="light">
        <div slot="content" class="content">
          <span class="fs-md fw-6 mb-2 title">电子保函</span>
          <span class="fs-lg fw-6 mb-3">400616-6620 转3</span>
          <!-- <span class="fs-md fw-6 mb-2 title">购买CA</span>
          <span class="fs-lg fw-6 mb-3">400616-6620</span> -->
          <span class="fs-md fw-6 mb-2 title">履约保函</span>
          <span class="fs-lg fw-6 mb-2">肖经理 15779672596</span>
          <img v-if="!isBsgzw" :src="this.$cdn.kefu" />
        </div>
        <img src="../../assets/fixed/kefu@3x.png" alt="" />
      </el-tooltip>
    </div>
    <!-- <div>
      <el-tooltip content="帮助中心" placement="left" effect="light">
        <img
          src="../../assets/fixed/bangzhu@3x.png"
          alt=""
          @click="handleHelp"
        />
      </el-tooltip>
    </div> -->
    <div>
      <el-tooltip content="回到顶部" placement="left" effect="light">
        <img src="../../assets/fixed/top@3x.png" alt="" @click="toTop" />
      </el-tooltip>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {
    // 此处true需要加上，不加滚动事件可能绑定不成功
    window.addEventListener('scroll', this.handleScroll, true)
  },
  computed: {
    isBsgzw() {
      return this.$store.state.letter.isBsgzw
    },
  },
  methods: {
    handleScroll() {
      let scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      scrollTop > 30 ? (this.gotop = true) : (this.gotop = false)
    },
    toTop() {
      let top = document.documentElement.scrollTop || document.body.scrollTop
      // 实现滚动效果
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= 0) {
          clearInterval(timeTop)
        }
      }, 15)
    },
    up() {
      document.getElementsByClassName('scrollTop')[0].scrollTop = 0
    },
    handleHelp() {
      this.$router.push('/help')
    },
  },
}
</script>
<style scoped lang="scss">
.fixed {
  cursor: pointer;
  position: fixed;
  width: 50px;
  right: 50px;
  bottom: 100px;
  text-align: center;
  z-index: 9999;

  img {
    display: block;
    width: 100%;
    margin-bottom: 8px;
  }
}

.content {
  padding: 10px;

  span {
    display: block;
    font-size: 14px;
  }
  .title {
    color: #bbb;
  }

  img {
    width: 100px;
    height: 100px;
  }
}
</style>
